import { render, staticRenderFns } from "./total_transaksi.vue?vue&type=template&id=0883de49&"
import script from "./total_transaksi.vue?vue&type=script&lang=js&"
export * from "./total_transaksi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports